import { useEffect, useMemo, useState } from 'react';
import { CustomEventName, getUserAttributes } from '@mb/lib';
import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from '../api/orders';
import { LAST_ORDER_DATE_NO_LATER_THAN } from '../config';
import { ordersSelector } from '../redux/selectors/ordersSelector';
import { TreatmentAttributes } from '../types';

interface IUseDialogBehavior {
  treatmentAttrs: TreatmentAttributes;
  lastOrderCutoff: number;
  isForcedOpen: boolean;
  setIsForcedOpen: (isForcedOpen: boolean) => void;
}

export const useDialogBehavior = (): IUseDialogBehavior => {
  const dispatch = useDispatch();
  const customer = getUserAttributes();
  const groupId = customer?.groupId;
  const isTestUser = customer?.isTestUser;
  const [lastOrderCutoff] = useState(LAST_ORDER_DATE_NO_LATER_THAN);
  const { orders } = useSelector(ordersSelector);
  const [isForcedOpen, setIsForcedOpen] = useState(false);

  useEffect(() => {
    if (isForcedOpen) {
      dispatch(getOrders());
    }
  }, [isForcedOpen]);

  const handleOpenModal = () => {
    setIsForcedOpen(true);
  };

  useEffect(() => {
    window.addEventListener(
      CustomEventName.OPEN_ASK_PRODUCT_QUESTION_DIALOG,
      handleOpenModal,
    );
    return () => {
      window.removeEventListener(
        CustomEventName.OPEN_ASK_PRODUCT_QUESTION_DIALOG,
        handleOpenModal,
      );
    };
  }, []);

  const treatmentAttrs = useMemo(
    () =>
      orders && {
        groupID: groupId,
        isTestUser,
        hasOrderedWithinThirtyDays: orders.some(({ created_at }) => {
          return new Date(created_at) >= new Date(lastOrderCutoff);
        }),
      },
    [orders, lastOrderCutoff, groupId, isTestUser],
  );

  return { treatmentAttrs, lastOrderCutoff, isForcedOpen, setIsForcedOpen };
};
